<template>
  <div class="myculturedetails">
    <div class="mydetails m-4 flex ">
      <div class="w-1/4 bg-grid-color-secondary h-12 px-2">

        <vx-card style="max-width: 450px;" title="企业文化考核项填写">
          <vs-breadcrumb
              :items="[{title: '我的企业文化',url: '/user/myculture'},{title: '企业文化详情',active: true}]"></vs-breadcrumb>
          <div style="padding:.3rem .75rem;">最新保存时间: {{ time }}</div>
        </vx-card>
        <br/>
        <vs-sidebar static-position default-index="1">
          <div class="header-sidebar" slot="header">
            <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
              <vs-avatar size="70px" color="primary" text="龙翔" style="font-size: 17px;"/>
              <h5 class="mb-4 mt-2">{{ user.userName }}</h5>
            </div>
            <h4>企业文化考核项</h4>
            <p class="mt-2 text-danger" style="font-size: 16px;">当前总分：<span>{{ grade }}</span></p>
          </div>
          <div class="px-6 py-4" v-for="(item,index) in info" :key="item.dimension" >
            <h5>{{ rpBig(index + 1) + '.' + item.dimension }}</h5>
            <div class="flex mt-6 cursor-pointer" :class="isselect==index&&isitem==i?'text-primary':''"
                 v-for="(t,i) in item.templateInfoVo" :key="i" @click="getItem(index,i,t)">
              <span class="text-lg ml-3">{{ t.number }}.{{ t.behaviors }}<em
                  class="text-danger">(得分：{{ t.selfEvaluation }})</em></span>
            </div>
          </div>
        </vs-sidebar>
      </div>
      <div class="w-3/4 bg-grid-color h-12 px-2" v-if="info">
        <vx-card :title="current.behaviors" class="p-10" style="min-height:75vh">
          <div class="item">
            <p class="mb-4"><span class="text-warning">行为标准：</span>{{ current.standards }}</p>
            <p class="mb-4" v-if="current.prominentEvidence"><span class="text-warning">举证突出：</span>{{ current.prominentEvidence }}</p>
            <p class="mb-4"><span class="text-warning">评分标准：</span>{{ current.markingCriterion }}</p>
          </div>
          <vs-divider/>
          <div class="mt-5">
            <form>
              <div class="vx-row">
                <div class="vx-col w-full flex" style="align-items: center;">
                  <el-tooltip popper-class="popper" class="item" effect="dark" placement="top-start">
                    <div slot="content">
                      <pre>{{ current.firstMonthEvidence }}</pre>
                    </div>
                    <i class="el-icon-warning-outline"></i>
                    <p>上月填写内容示例</p>
                  </el-tooltip>
                </div>
                <div class="vx-col w-full mt-4 text">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>行为佐证</span>
                      </div>
                    </template>
                    <vs-textarea v-model="current.evidence" contenteditable="true" height="150px" style="height:200px"
                                 :placeholder="current.evidenceTips"/>
                  </vx-input-group>
                </div>
                <div class="vx-col w-full mt-10">
                  <vx-input-group class="mb-base">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>佐证来源</span>
                      </div>
                    </template>

                    <vs-textarea v-model="current.evidenceSource" :placeholder="current.evidenceSourceTips"/>
                  </vx-input-group>
                </div>
                <div class="vx-col w-full mt-4">
                  <vx-input-group class="mb-base flex items-center">
                    <template slot="prepend">
                      <div class="prepend-text bg-primary mr-10">
                        <span>自主评分</span>
                      </div>
                    </template>
                    <ul class="centerx flex items-center">
                      <el-radio-group v-model="current.selfEvaluation">
                        <el-radio class="elradio" :label="c" v-for="(c,p) in current.optionalScore" :key="p">{{ c }}分</el-radio>
                      </el-radio-group>

                      <!-- <li style="width: 100px;" v-for="(c,p) in current.optionalScore" :key="p">
                        <vs-radio v-model="current.selfEvaluation"   :vs-value="c">{{c}}分</vs-radio>
                      </li> -->
                    </ul>
                  </vx-input-group>
                </div>
              </div>
              <div class="vx-col w-full mt-4 flex">
                <vs-button type="filled" @click.prevent="submitForm" class="mt-5 mr-6 block">保存</vs-button>
                <vs-button type="filled" color="success" @click.prevent="next" class="mt-5 mr-6 block">下一条
                </vs-button>
                <vs-button type="filled" color="success" @click.prevent="last" class="mt-5 block">上一条</vs-button>
              </div>
            </form>
          </div>
        </vx-card>
      </div>
    </div>

  </div>

</template>
<script>
import {nowtime, rp} from "../../../utils/format"

export default {
  data() {
    return {
      user: '',
      id: '',
      info: '',
      isselect: 0,   //选择的维度
      isitem: 0,     //选择的项
      current: '',   //当前选择项内容
      grade: 0,      //总分
      time: '------',      //最新保存时间
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("userdetails"));
    this.id = this.$route.query.id;
    this.getdetails();
    const that = this;
    // setInterval(function(){
    // 	that.submitForm();
    // },60000)
  },
  computed: {
    changeData() {
      const {isitem, isselect} = this
      return {isitem, isselect}
    }
  },
  watch: {
    current: {
      handler(newvalue, oldvalue) {
        console.log("你在作甚", newvalue, oldvalue);
        this.info[this.isselect].templateInfoVo[this.isitem] = newvalue;
        this.getgrade();
      },
      deep: true
    },
    changeData(val) {
      this.submitForm();
    },

  },
  methods: {
    rpBig(num) {
      return rp(num);
    },
    submitForm() {     //保存标准
      const that = this;
      var obj = [];
      obj = JSON.parse(JSON.stringify(this.info));
      for (var i = 0; i < obj.length; i++) {
        for (var j = 0; j < obj[i].templateInfoVo.length; j++) {
          obj[i].templateInfoVo[j].optionalScore = obj[i].templateInfoVo[j].optionalScore.toString();
        }
      }
      console.log("保存标准", obj);
      this.$vs.loading();
      this.$api.staffsaveall(obj, {'content-type': 'application/json'}).then(function (response) {
        console.log("保存结果：", response);
        that.$vs.loading.close();
        if (response.code == 0) {
          that.time = nowtime();
          that.$vs.notify({
            title: "提示",
            color: 'success',
            text: "保存成功",
            position: 'top-center'
          });
        } else {
          that.$vs.notify({
            title: "提示",
            color: 'warning',
            text: response.message,
            position: 'top-center'
          });
        }
      }).catch(err => {
        console.log("错误", err);
        that.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "网络错误请重新提交",
          position: 'top-center'
        });
      })
    },
    last() {
      if (this.isselect == 0 && this.isitem == 0) {
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "已经到顶了",
          position: 'top-center'
        });
      } else if (this.isitem > 0) {
        console.log(222);
        this.isitem = this.isitem - 1;
        this.current = this.info[this.isselect].templateInfoVo[this.isitem];
      } else if (this.isselect > 0 && this.isitem == 0) {
        this.isselect = this.isselect - 1;
        this.isitem = this.info[this.isselect].templateInfoVo.length - 1;
        this.current = this.info[this.isselect].templateInfoVo[this.isitem];
      } else {
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "已经到顶了~",
          position: 'top-center'
        });
      }
    },
    next() {
      console.log(this.isselect, this.isitem);
      if (this.isselect <= this.info.length - 1 && this.isitem < this.info[this.isselect].templateInfoVo.length - 1) {
        console.log(111);
        this.isitem = this.isitem + 1;
        this.current = this.info[this.isselect].templateInfoVo[this.isitem];
      } else if (this.isselect < this.info.length - 1 && this.isitem == this.info[this.isselect].templateInfoVo.length - 1) {
        console.log(222);
        this.isitem = 0;
        this.isselect = this.isselect + 1;
        this.current = this.info[this.isselect].templateInfoVo[this.isitem];
      } else if (this.isselect == this.info.length - 1 && this.isitem == this.info[this.isselect].templateInfoVo.length - 1) {
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "没有下一条了~",
          position: 'top-center'
        });
      } else {
        this.$vs.notify({
          title: "提示",
          color: 'warning',
          text: "没有下一条了~",
          position: 'top-center'
        });
      }
    },
    getItem(index, i, item) {		//一项的内容
      this.isselect = index;
      this.isitem = i;
      this.current = item;
      console.log("该项内容", index, item);
    },
    getgrade() {			//计算总分
      var that = this;
      that.grade = 0;
      for (var i = 0; i < that.info.length; i++) {
        for (var j = 0; j < that.info[i].templateInfoVo.length; j++) {
          that.grade = parseInt(that.grade) + parseInt(that.info[i].templateInfoVo[j].selfEvaluation);
        }
      }
    },
    getdetails() {   //获取详情
      const that = this;
      this.$api.staffdetails({id: that.id}).then(function (response) {
        console.log("详情：", response);
        if (response.code == 0) {
          that.info = response.data;
          if (that.info.length == 5) {
            that.info.pop();
          }
          for (var i = 0; i < that.info.length; i++) {
            for (var j = 0; j < that.info[i].templateInfoVo.length; j++) {
              that.info[i].templateInfoVo[j].optionalScore = that.info[i].templateInfoVo[j].optionalScore ? that.info[i].templateInfoVo[j].optionalScore.split(",") : [];
              that.info[i].templateInfoVo[j].selfEvaluation = that.info[i].templateInfoVo[j].selfEvaluation + "";
              if (that.info[i].templateInfoVo[j].evidence == "" || that.info[i].templateInfoVo[j].evidence == null) {
                that.info[i].templateInfoVo[j].evidence = that.info[i].templateInfoVo[j].evidenceTips;
              }
              if (that.info[i].templateInfoVo[j].evidenceSource == "" || that.info[i].templateInfoVo[j].evidenceSource == null) {
                that.info[i].templateInfoVo[j].evidenceSource = that.info[i].templateInfoVo[j].evidenceSourceTips;
              }
            }
          }
          that.current = that.info[that.isselect].templateInfoVo[that.isitem];
          that.getgrade();
        } else {
          that.$vs.notify({
            title: "提示",
            color: 'warning',
            text: response.message,
            position: 'top-center'
          });
        }
      })
    },
  },
}
</script>
<style type="text/css">
.el-tooltip__popper.is-dark {
  white-space: pre-wrap !important;
}

.elradio {
  margin-right: 20px;
}
.el-radio__label {
  padding-left: 6px;
}

.myculturedetails .parentx-static {
  overflow: hidden;
  height: 500px;
  position: relative;
}

.myculturedetails .header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.myculturedetails h4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.myculturedetails h5 {
  font-weight: 600;
}

.myculturedetails .vs-sidebar--background {
  background: none !important;
  max-width: 450px !important;
  width: auto !important;
}

.myculturedetails .vs-sidebar .vs-sidebar--items {
  max-height: 65vh !important;
  overflow: auto !important;
}

.myculture .vs-sidebar--items {
  -ms-overflow-style: none !important; /* IE 10+ */
  scrollbar-width: none !important; /* Firefox */
}

::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.myculturedetails .vs-sidebar {
  max-width: 450px;
}

.myculturedetails .item {
  font-size: 16px;
}

.myculturedetails .el-radio__input.is-checked + .el-radio__label {
  color: #7367F0 !important;
  transform: scale(1.2);
}

.myculturedetails .el-radio__input.is-checked .el-radio__inner {
  background: #7367F0 !important;
  border-color: #7367F0 !important;
  transform: scale(1.5);
}

.myculturedetails .text textarea.vs-textarea {
  height: 150px !important;
}
</style>
